import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ArticleIcon from '@mui/icons-material/Article';
import { useDispatch } from 'react-redux';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { downloadReportJob } from '../dataHandlers/downloadReportJobHandler';

const ReportActionsMenu = ({
  filePath,
  jobId,
  useAuthenticatedDownload = false,
  downloadDefaultFileName,
  downloadInsufficientAccessMessage,
  disabled = false,
}) => {
  const { documentReports: dr } = useTranslatedMessages();
  const actionsT = dr.actions_menu ?? {};
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    if (!disabled) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDownload = () => {
    if (useAuthenticatedDownload && jobId) {
      downloadReportJob(jobId, {
        dispatch,
        defaultFileName: downloadDefaultFileName,
        insufficientAccessMessage: downloadInsufficientAccessMessage,
      });
    } else if (filePath) {
      window.open(filePath, '_blank');
    }
    handleClose();
  };

  const downloadDisabled = useAuthenticatedDownload ? !jobId : !filePath;

  return (
    <>
      <IconButton
        aria-label={actionsT.aria_more ?? 'more'}
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
        disabled={disabled}
        sx={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu id="long-menu" anchorEl={anchorEl} open={open} onClose={handleClose} onClick={(e) => e.stopPropagation()}>
        <MenuItem onClick={handleDownload} disabled={downloadDisabled}>
          <ArticleIcon sx={{ mr: 1 }} />
          {actionsT.download_report ?? 'Download Report'}
        </MenuItem>
      </Menu>
    </>
  );
};

export default ReportActionsMenu;
